<script setup lang="ts">
  import { PropType } from 'vue'
  import { useEventsBus } from '@haskoning/vue-component-library'
  import type { SectionLineUploadCollection } from '@/stores/type/sectionLine.type'
  import { useSectionLineUploadCollectionsStore } from '@/stores/sectionLineUploadCollections'
  import useProfilePermissions from '@/composables/useProfilePermission'

  const { canEditSectionLineUploadCollection } = useProfilePermissions()
  const props = defineProps({
    store: {
      type: Object,
      required: true
    },
    item: {
      type: Object as PropType<SectionLineUploadCollection>,
      required: true
    }
  })
  const sectionLineUploadCollectionsStore = useSectionLineUploadCollectionsStore()
  const { emit } = useEventsBus()

  const emitShowItem = (event: MouseEvent) => {
    if (props.item.hidden) {
      props.store.toggleItem(props.item)
      event.stopPropagation()
    }
    emit('showItem', { hidden: props.item.hidden, item: props.item })
  }

  const emitFlyToCollection = (item: SectionLineUploadCollection) => {
    if (item.sectionline_set.features.length === 0) return
    emit('fly-to-collection', item)
  }

  watch(
    () => sectionLineUploadCollectionsStore.isSelected(props.item.id),
    () => {
      if (sectionLineUploadCollectionsStore.isSelected(props.item.id)) {
        sectionLineUploadCollectionsStore.addSelectedSectionLineCollection(props.item)
      } else sectionLineUploadCollectionsStore.removeSelectedSectionLineCollection(props.item)
    }
  )
</script>

<template>
  <v-list-item-title
    class="d-flex mt-0 mb-0 justify-space-between pl-2"
    :class="props.item.hidden ? 'opacity clickable' : 'clickable'"
    @click="emitShowItem($event)"
  >
    <div class="d-flex align-center justify-start g-2">
      <v-checkbox
        color="primary"
        density="compact"
        :model-value="sectionLineUploadCollectionsStore.isSelected(props.item.id)"
        hide-details
        class="ml-n1"
        @update:model-value="
          sectionLineUploadCollectionsStore.toggleCollection(
            !sectionLineUploadCollectionsStore.isSelected(props.item.id),
            props.item.id
          )
        "
        @click.stop=""
      ></v-checkbox>
      <strong class="text-primary" @click.stop="emitFlyToCollection(props.item)">
        {{ props.item.name }}</strong
      >
      <v-icon
        v-if="canEditSectionLineUploadCollection"
        color="primary"
        class="cursor-pointer"
        @click.stop="sectionLineUploadCollectionsStore.toggleCreateUpdateDialog(props.item)"
        >mdi-pencil
      </v-icon>
    </div>
  </v-list-item-title>
</template>

<style scoped>
  .clickable {
    cursor: pointer;
  }

  .opacity {
    opacity: 0.5;
  }
</style>
